import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import FlowModelImporter from '@Client/runner.import/flowmodels/components/FlowModelImporter';

const FlowModelImporterBridge = react2angular(FlowModelImporter, ['close']);

export default FlowModelImporterBridge;
